/* hairUP  |  PDP + sekcje wspierajace sprzedaz. Bez zaleznosci zewnetrznych. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var smooth = reduce ? 'auto' : 'smooth';
  var root = function () { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; };

  function once(el, key) {
    if (!el || el.dataset[key] === 'true') return false;
    el.dataset[key] = 'true';
    return true;
  }

  function all(scope, sel) { return Array.prototype.slice.call(scope.querySelectorAll(sel)); }

  /* ---------- uniwersalna nawigacja karuzeli ----------------- */
  function railNav(scope) {
    all(scope, '[data-rail-prev], [data-rail-next]').forEach(function (btn) {
      if (!once(btn, 'huRailNav')) return;
      var sec = btn.closest('section');
      var rail = sec && sec.querySelector('.hu-rail');
      if (!rail) return;
      var back = btn.hasAttribute('data-rail-prev');
      btn.addEventListener('click', function () {
        var first = rail.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: back ? -step : step, behavior: smooth });
      });
    });
  }

  /* ---------- galeria produktu ------------------------------ */
  function gallery(scope) {
    all(scope, '[data-hu-gallery]').forEach(function (gal) {
      if (!once(gal, 'huGallery')) return;
      var track = gal.querySelector('.hu-gal__track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var count = gal.querySelector('[data-gallery-count]');
      var thumbs = all(gal, '.hu-gal__thumb');
      var index = 0;

      function render() {
        if (count) count.textContent = (index + 1) + ' / ' + slides.length;
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
        slides.forEach(function (s, i) {
          if (i !== index) { var v = s.querySelector('video'); if (v && !v.paused) v.pause(); }
        });
      }
      function go(n) {
        index = Math.max(0, Math.min(slides.length - 1, n));
        track.scrollTo({ left: index * track.clientWidth, behavior: smooth });
        render();
      }
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var w = track.clientWidth || 1;
          var next = Math.round(track.scrollLeft / w);
          if (next !== index) { index = next; render(); }
        });
      }, { passive: true });

      var prev = gal.querySelector('[data-gallery-prev]');
      var next = gal.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      render();
    });
  }

  /* ---------- wybor zestawu + koszyk ------------------------- */
  function product(scope) {
    all(scope, '[data-hu-product]').forEach(function (pdp) {
      if (!once(pdp, 'huProduct')) return;
      var form = pdp.querySelector('form.hu-form');
      if (!form) return;

      var sticky = pdp.querySelector('[data-hu-sticky]');
      if (sticky) {
        all(document, 'body > [data-hu-sticky]').forEach(function (el) { el.remove(); });
        document.body.appendChild(sticky);
      }

      var sumLabel = pdp.querySelector('[data-sum-label]');
      var sumPrice = pdp.querySelector('[data-sum-price]');
      var stLabel = sticky && sticky.querySelector('[data-sticky-label]');
      var stPrice = sticky && sticky.querySelector('[data-sticky-price]');

      function sync() {
        var variant = form.querySelector('input[name="id"]:checked');
        var variantLabel = form.querySelector('.hu-vp__value');
        if (variant && variantLabel) variantLabel.textContent = variant.closest('label').querySelector('.hu-vp__pill').textContent;
        var picked = form.querySelector('input[name="quantity"]:checked');
        if (!picked) return;
        var label = picked.dataset.label || '';
        var price = picked.dataset.priceFormatted || '';
        if (sumLabel) sumLabel.textContent = label;
        if (sumPrice) sumPrice.textContent = price;
        if (stLabel) stLabel.textContent = label;
        if (stPrice) stPrice.textContent = price;
      }
      form.addEventListener('change', sync);
      sync();

      var atc = form.querySelector('[data-hu-atc]');
      var stBtn = sticky && sticky.querySelector('button');

      if (sticky && atc && 'IntersectionObserver' in window) {
        sticky.hidden = false;
        sticky.dataset.show = 'false';
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          sticky.dataset.show = passed ? 'true' : 'false';
        }, { threshold: 0 }).observe(atc);
      } else if (sticky) {
        sticky.hidden = true;
      }

      var busy = false;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (busy) return;
        busy = true;
        var err = pdp.querySelector('[data-hu-error]');
        if (err) { err.hidden = true; err.textContent = ''; }
        var buttons = [atc, stBtn].filter(Boolean);
        var original = atc ? atc.innerHTML : '';
        buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        if (atc) atc.textContent = 'Dodaję do koszyka...';
        var data = new FormData(form);
        data.set('sections', 'hairup-cart-drawer');
        data.set('sections_url', root() + 'cart');

        fetch(root() + 'cart/add.js', {
          method: 'POST',
          body: data,
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Nie udało się dodać produktu.');
            if (window.hairUPCart) return window.hairUPCart.added(res.data.sections);
            window.location.assign(root() + 'cart');
          })
          .catch(function (ex) {
            if (err) { err.textContent = ex.message || 'Sprawdź połączenie i spróbuj ponownie.'; err.hidden = false; }
          })
          .finally(function () {
            if (atc) atc.innerHTML = original;
            buttons.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
            busy = false;
          });
      });
    });
  }

  /* ---------- akordeony -------------------------------------- */
  function accordions(scope) {
    all(scope, '[data-hu-acc]').forEach(function (acc) {
      if (!once(acc, 'huAcc')) return;
      all(acc, '.hu-acc__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          if (panel) panel.dataset.open = open ? 'false' : 'true';
        });
      });
    });
  }

  /* ---------- karuzela video (social proof) ------------------ */
  function videoRail(scope) {
    all(scope, '[data-hu-videos]').forEach(function (sec) {
      if (!once(sec, 'huVideos')) return;
      var rail = sec.querySelector('.hu-rail');
      if (!rail) return;
      var cards = all(sec, '[data-hu-vcard]');

      function step() {
        var first = cards[0];
        return first ? first.getBoundingClientRect().width + 12 : rail.clientWidth * 0.8;
      }
      var prev = sec.querySelector('[data-video-prev]');
      var next = sec.querySelector('[data-video-next]');
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: smooth }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: smooth }); });

      function pauseOthers(current) {
        cards.forEach(function (c) {
          var v = c.querySelector('video');
          if (v && v !== current && !v.paused) { v.pause(); c.dataset.playing = 'false'; c.dataset.loading = 'false'; }
        });
      }

      cards.forEach(function (card) {
        var v = card.querySelector('video');
        var poster = card.querySelector('[data-hu-poster]');
        var toggle = card.querySelector('[data-hu-play]');
        var sound = card.querySelector('[data-hu-sound]');
        if (!v) return;

        function loading(on) { card.dataset.loading = on ? 'true' : 'false'; }

        function revealFrame() {
          card.dataset.playing = 'true';
          if (poster) { poster.hidden = true; poster.style.display = 'none'; }
          if (toggle) toggle.setAttribute('aria-label', 'Zatrzymaj film');
        }

        function play() {
          if (!v.dataset.loaded) {
            all(v, 'source[data-src]').forEach(function (s) { s.src = s.dataset.src; });
            v.load();
            v.dataset.loaded = 'true';
          }
          pauseOthers(v);
          loading(true);
          var p = v.play();
          if (p && p.catch) p.catch(function () { loading(false); });
        }

        if (toggle) {
          toggle.addEventListener('click', function () {
            if (v.paused) play(); else v.pause();
          });
        }

        v.addEventListener('play', function () { pauseOthers(v); if (v.readyState < 3) loading(true); });
        v.addEventListener('waiting', function () { loading(true); });
        v.addEventListener('loadeddata', function () { if (!v.paused) revealFrame(); });
        v.addEventListener('playing', function () { loading(false); revealFrame(); pauseOthers(v); });
        v.addEventListener('timeupdate', function () { if (card.dataset.playing !== 'true' && v.currentTime > 0) revealFrame(); });
        v.addEventListener('pause', function () {
          loading(false);
          card.dataset.playing = 'false';
          if (toggle) toggle.setAttribute('aria-label', 'Odtwórz film');
        });
        v.addEventListener('error', function () { loading(false); });

        if (sound) {
          sound.addEventListener('click', function () {
            v.muted = !v.muted;
            sound.dataset.muted = v.muted ? 'true' : 'false';
            sound.setAttribute('aria-label', v.muted ? 'Włącz dźwięk' : 'Wycisz');
            if (v.paused) play();
          });
        }
      });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) {
              var v = e.target.querySelector('video');
              if (v && !v.paused) { v.pause(); e.target.dataset.playing = 'false'; e.target.dataset.loading = 'false'; }
            }
          });
        }, { threshold: 0.25 });
        cards.forEach(function (c) { io.observe(c); });
      }
    });
  }

  /* ---------- suwak przed / po ------------------------------- */
  function beforeAfter(scope) {
    all(scope, '[data-hu-ba]').forEach(function (ba) {
      if (!once(ba, 'huBa')) return;
      var input = ba.querySelector('input[type="range"]');
      var stage = ba.querySelector('.hu-ba__stage');
      if (!input || !stage) return;
      var apply = function () { stage.style.setProperty('--split', input.value + '%'); };
      input.addEventListener('input', apply);
      apply();
    });
  }

  function init(scope) {
    var s = scope || document;
    railNav(s);
    gallery(s);
    product(s);
    accordions(s);
    videoRail(s);
    beforeAfter(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
